import React, { FC } from 'react';
import { useHistory } from 'react-router';

import { SubcategoryResponse } from '../../category/model/categoryModel';
import Button from '../../../components/form/elements/Button';
import { BUTTON_COLOR, BUTTON_VARIANT } from '../../../components/form/enum/formProps';
import { ROUTES } from '../../../core/router/routes';
import useMainProgressContext from '../../../components/progress/MainProgress/context/MainProgressContext';
import './subcategories.scss';

interface SubcategoriesProps {
  subcategories: SubcategoryResponse[];
}

const Subcategories: FC<SubcategoriesProps> = (props) => {
  const history = useHistory();
  const { show } = useMainProgressContext();
  const subcategories = props.subcategories.slice();

  return (
    <div className="Subcategories-Wrapper">
      {subcategories
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(({ id, iri, name }) => {
          return (
            <Button
              key={iri}
              text={name}
              color={BUTTON_COLOR.DEFAULT}
              variant={BUTTON_VARIANT.OUTLINED}
              onClick={() => {
                history.push(ROUTES.CATEGORY.ARTICLE.replace(':id', id as unknown as string));
                show();
              }}
            />
          );
        })}
    </div>
  );
};

export default Subcategories;
